import { api, endpoints } from "api/api";
import { BaseApiPaging } from "api/types";
import { AxiosPromise } from "axios";
import { PlaceFormValues } from "pages/Places/PlaceForm/PlaceForm";

const create = (data: PlaceFormValues): AxiosPromise => {
  return api.post(endpoints.PLACES.CREATE(), data);
};

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = ""
): AxiosPromise<BaseApiPaging<PlaceApi>> => {
  return api.get<BaseApiPaging<PlaceApi>>(endpoints.PLACES.GET(skip, take, searchPhrase, filter, orderBy));
};

const fetchById = (placeId: number): AxiosPromise<PlaceApi> => {
  return api.get<PlaceApi>(endpoints.PLACES.GET_BY_ID(placeId));
};

const update = (placeId: number, data: PlaceFormValues): AxiosPromise<PlaceApi> => {
  return api.put<PlaceApi>(endpoints.PLACES.UPDATE(placeId), data);
};

const deletePlace = (placeId: number): Promise<void> => {
  return api.delete(endpoints.PLACES.DELETE(placeId));
};

export const placesApi = {
  create,
  fetch,
  fetchById,
  update,
  delete: deletePlace,
};

export interface PlaceApi {
  id: number;
  name: string;
  description: string;
  address: string;
  city: string;
  postCode: string;
  latitude: string;
  longitude: string;
  directions: string;
  email: string;
  phone: string;
  website: string;
  createdDate: Date;
  tags: {
    id: number;
    name: string;
  }[];
}
